export default __webpack_public_path__ + "static/media/setting-blue.b82bb2a7.svg";